import { render, staticRenderFns } from "./erpskuinput.vue?vue&type=template&id=e186fa2e&scoped=true"
import script from "./erpskuinput.vue?vue&type=script&lang=js"
export * from "./erpskuinput.vue?vue&type=script&lang=js"
import style0 from "./erpskuinput.vue?vue&type=style&index=0&id=e186fa2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e186fa2e",
  null
  
)

export default component.exports